import {Power3, TimelineLite, TweenLite} from "gsap";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {Container} from "pixi.js";
import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {DDay} from "../../game/DDay";
import {BlitzKriegParsedGameData} from "../../game/server/data/BlitzKriegParsedGameData";
import {BlitzKriegParsedInitData} from "../../game/server/data/BlitzKriegParsedInitData";
import {BlitzKriegGameMode} from "../../game/server/BlitzKriegGameMode";

export class GameHelper {
    private static shake: boolean = true;

    public static getSpineDuration(spineObj: PIXI.spine.Spine, animName: string): number {
        return spineObj.skeleton.data.findAnimation(animName).duration;
    }

    public static resetSpine(spineObj: PIXI.spine.Spine, show: boolean = false): void {
        spineObj.state.clearTracks();
        spineObj.skeleton.setToSetupPose();
        spineObj.skeleton.setBonesToSetupPose();
        spineObj.skeleton.setSlotsToSetupPose();
        spineObj.state.setEmptyAnimation(0, 0);
        spineObj.visible = show;
    }

    public static createSprite(spriteName: string): PIXI.Sprite {
        const spriteImg: PIXI.Sprite = new PIXI.Sprite(DDay.assetLoader.getTextures(spriteName)[0]);
        spriteImg.name = spriteName;
        spriteImg.anchor.set(0.5);
        return spriteImg;
    }

    public static createSpine(spineName: string): PIXI.spine.Spine {
        const spineObj: PIXI.spine.Spine = new PIXI.spine.Spine(DDay.assetLoader.getSpineAsset(spineName));
        spineObj.name = spineName;
        spineObj.position.set(360);
        spineObj.visible = false;
        return spineObj;
    }

    public static createImageSeq(seqName: string): TimelineSprite {
        const imgSeq: TimelineSprite = new TimelineSprite(DDay.assetLoader.getTextures(seqName));
        imgSeq.name = seqName;
        imgSeq.anchor.set(0.5);
        imgSeq.hide();
        return imgSeq;
    }

    public static playSpineAnimation(spineObj: PIXI.spine.Spine, animName: string, skinName: string = "default", playLoop: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            animDur: number = this.getSpineDuration(spineObj, animName);

        tl.to(this, {
            duration: Math.max(0.033, animDur),
            onStart: () => {
                this.resetSpine(spineObj, true);
                spineObj.skeleton.setSkinByName(skinName);
                spineObj.state.setAnimation(0, animName, playLoop);
            }
        });

        return tl;
    }

    public static pauseSpineAnimation(spineObj: PIXI.spine.Spine): void {
        if (spineObj.state.timeScale > 0) {
            spineObj.state.timeScale = 0;
        }
    }

    public static resumeSpineAnimation(spineObj: PIXI.spine.Spine): void {
        if (spineObj.state.timeScale === 0) {
            spineObj.state.timeScale = 1;
        }
    }

    public static isIpad(): boolean {
        const resizeData: ScreenBounds = NolimitApplication.screenBounds;
        if (NolimitApplication.isLandscape) {
            return (resizeData.width >= 955 && resizeData.width <= 965);
        } else {
            return (resizeData.height >= 955 && resizeData.height <= 965);
        }
    }


    public static isBoostedBetAllowed(): boolean {
        return DDay.apiPlugin.gameClientConfiguration.boostedBetAllowed;
    }

    public static getParsedData(): BlitzKriegParsedGameData | BlitzKriegParsedInitData {
        return DDay.model.parsedGameData ? DDay.model.parsedGameData : DDay.model.parsedInitData;
    }

    public static isBonusGame(mode: BlitzKriegGameMode): boolean {
        return mode === BlitzKriegGameMode.FREESPIN || mode === BlitzKriegGameMode.FREESPIN_SUPER;
    }
}
